import { VOICES } from "@/components/VoicesShowcase";

/*
  黒い面に縦書きの紙面を敷く (案 D、exp/women-bg-direction、2026-10-12 にオーナーが選んだ)。オーナーの手本は、暗い地に縦書きの紙面と小さな広告の枠がごく薄く透ける端末の背景。
  黒い面 (楽な約束はしない、30ヶ月) の後ろに、縦書きの明朝で組んだ紙面を、字が読めるか読めないかの薄さで敷く。
  - 字は架空の記事を作らず、受講生の声 (VoicesShowcase の VOICES) と、このページの宣言の文をそのまま組む
  - 画像にせず CSS の writing-mode で組む。段の罫と広告の枠で新聞らしさを出す
  - 支援技術に読ませない (aria-hidden)、選べない、動かない。前の字が載る中ほどは地の字をさらに薄くする
  切り替えはなく、常にこの見た目で出す
*/

// 声の ** は太字の印なので外す
const plain = (s: string) => s.replace(/\*\*/g, "");

// 広告の枠に入れる字。どれもこのページにある宣言の文
const ADS = ["実践主義。", "そんな約束はしない。", "ひとりにしない。", "受講料に込み。"];

// 紙面ごとに使う声の番号。楽な約束はしない (学びの中身) と、30ヶ月 (支え) で分ける
const PICK = { npb: [3, 7, 5, 2, 6, 0], m30: [0, 1, 4, 6, 2, 5] } as const;

export function PaperBg({ kind }: { kind: keyof typeof PICK }) {
  const voices = PICK[kind].map((i) => VOICES[i]);
  return (
    <div className="bgp" aria-hidden="true">
      {[0, 1].map((band) => (
        <div key={band} className="bgp-band">
          {voices.map((v, i) => {
            const n = (i + band * 3) % voices.length;
            // 広告の枠は 2 列目と 4 列目の下に置く (スマホでは 2 列目だけ見える)
            const ad = i === 1 || i === 3 ? ADS[(band * 2 + (i === 3 ? 1 : 0) + (kind === "m30" ? 2 : 0)) % ADS.length] : null;
            return (
              <div key={i} className="bgp-col">
                <p className="bgp-art">
                  <b>{voices[n].head}</b>
                  {plain(voices[n].quote)}
                  {plain(voices[(n + 1) % voices.length].quote)}
                </p>
                {ad && <p className="bgp-ad">{ad}</p>}
              </div>
            );
          })}
        </div>
      ))}
    </div>
  );
}

/* 地の字は白の 7%。前の字が載る所は mask で 4 割まで落とす。スマホは端も 7.5 割、PC は左右の余白だけ濃いまま */
export const PAPER_CSS = `
.bp:has(>.bgp){position:relative;isolation:isolate}
.bp:has(>.bgp)>.bp-in{position:relative;z-index:1}
.bp>.bgp{position:absolute;inset:0;z-index:0;display:flex;flex-direction:column;gap:14px;padding:14px 0;overflow:hidden;pointer-events:none;user-select:none;-webkit-user-select:none;color:rgba(255,255,255,.07);font-weight:400;-webkit-mask-image:linear-gradient(90deg,rgba(0,0,0,.75),rgba(0,0,0,.4) 14% 86%,rgba(0,0,0,.75));mask-image:linear-gradient(90deg,rgba(0,0,0,.75),rgba(0,0,0,.4) 14% 86%,rgba(0,0,0,.75))}
.bp>.bgp .bgp-band{flex:1;min-height:0;display:flex;flex-direction:row-reverse;gap:0;border-top:1px solid rgba(255,255,255,.07);border-bottom:1px solid rgba(255,255,255,.07);padding:10px 0}
.bp>.bgp .bgp-col{flex:none;display:flex;flex-direction:column;gap:10px;width:236px;padding:0 12px;border-left:1px solid rgba(255,255,255,.06)}
.bp>.bgp .bgp-art{flex:1;min-height:0;margin:0;writing-mode:vertical-rl;overflow:hidden;font-size:12px;line-height:1.75;letter-spacing:.06em;text-align:justify}
.bp>.bgp .bgp-art b{display:block;text-align:start;font-size:17px;font-weight:700;line-height:1.4;margin-left:10px;padding-left:8px;border-left:1px solid rgba(255,255,255,.06)}
.bp>.bgp .bgp-ad{flex:none;margin:0;display:grid;place-items:center;height:64px;border:3px double rgba(255,255,255,.08);font-size:14px;font-weight:700;letter-spacing:.1em}
@media (min-width:900px){
  .bp>.bgp{-webkit-mask-image:linear-gradient(90deg,#000 10%,rgba(0,0,0,.4) 22% 78%,#000 90%);mask-image:linear-gradient(90deg,#000 10%,rgba(0,0,0,.4) 22% 78%,#000 90%)}
  .bp>.bgp .bgp-col{width:260px}
  .bp>.bgp .bgp-art{font-size:13px}
}
`;
